import React, { useState, useEffect } from "react";
import ReactCountryFlag from "react-country-flag";
import { Select, Spin } from "antd";
import { getCurrencyCountry } from "../api/api";
import { getCountryCodeForCurrency } from "utils/utils";

const CurrencySelector = ({ size, defaultValue, onCurrencyChanged, className, currencies }) => {
  const [currencyCountryData, setCurrencyCountryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState(defaultValue);

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await getCurrencyCountry();
        setCurrencyCountryData(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching currency country data:", error);
        setError(error);
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const handleCurrencyChange = (value) => {
    console.log("Currency changed:", value);
    setSelectedCurrency(value);
    if (onCurrencyChanged) {
      onCurrencyChanged(value);
    }
  };

  if (loading) {
    return <Spin />;
  }

  if (error) {
    return <div>Error loading data: {error.message}</div>;
  }

  return (
    <span className="currency-selector-container">
      <Select
        showSearch
        size={size}
        value={selectedCurrency}
        onChange={handleCurrencyChange}
        optionFilterProp="children"
        filterOption={(input, option) => {
          return option.props.children[1].props.children.toLowerCase().includes(input.toLowerCase());
        }}
        className={className}
        style={{ width: '150px', fontSize: 16, borderRadius: '5px' }}
      >
        {currencies.map((currency) => {
          const countryCode = getCountryCodeForCurrency(currency);
          const countryData = currencyCountryData.find(
            item => item.currency === currency
          ) || { country: "Unknown", isoCodeAlpha2: countryCode };

          return (
            <Select.Option key={currency} value={currency} style={{ display: 'flex', alignItems: 'center' }}>
              <ReactCountryFlag code={countryCode.toUpperCase()} svg style={{ marginRight: '10px' }} />
              <span style={{ fontWeight: 'bold', lineHeight: '1.5em' , marginLeft: '10px', justifyContent: 'center'}}>{currency}</span>
            </Select.Option>
          );
        })}
      </Select>
    </span>
  );
};

export default CurrencySelector;

